import { Link } from 'react-router-dom';
import { FaTiktok, FaFacebook, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const socialLinks = [
  { href: 'https://www.tiktok.com/@blueboardesk8', icon: FaTiktok, 'aria-label': 'TikTok' },
  { href: 'https://www.facebook.com/profile.php?id=61570467006347', icon: FaFacebook, 'aria-label': 'Facebook' },
  { href: 'https://www.instagram.com/blueboardtlv/', icon: FaInstagram, 'aria-label': 'Instagram' },
];

const Footer = () => {
  const { t, i18n } = useTranslation();
  
  return (
    <footer id="main-footer" className="bg-gray-800 text-white" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
      <div className="container mx-auto py-8 px-6">
        <div className="flex flex-wrap text-center lg:text-right">
          <div className="w-full lg:w-6/12 px-4">
            <div className={`${i18n.language === 'en' ? 'text-left' : 'text-right'}`}>
              <h4 className="text-3xl font-semibold mb-1">{t('social.keepInTouch')}</h4>
              <h5 className="text-lg text-gray-400">{t('social.followUs')}</h5>
            </div>
            <div className="mt-6 lg:mb-0 mb-6 flex justify-center lg:justify-start gap-4">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link['aria-label']}
                  className="bg-white text-blue-600 shadow-lg font-normal h-10 w-10 flex items-center justify-center align-center rounded-full outline-none focus:outline-none"
                >
                  <link.icon className="text-xl" />
                </a>
              ))}
            </div>
          </div>
          
          <div className={`flex flex-row gap-8 mb-6 w-full md:w-auto ${i18n.language === 'en' ? 'justify-start' : 'justify-end'}`}> 
            <div className={`flex flex-col min-w-[200px] ${i18n.language === 'en' ? 'text-left' : 'text-right'}`}> 
              <span className="block uppercase text-gray-400 text-sm font-semibold mb-4">{t('footer.usefulLinks', 'קישורים שימושיים')}</span>
              <div className="flex flex-row flex-wrap gap-6">
                <div className="flex flex-col gap-2 min-w-[80px]">
                  <Link to="/" className="text-gray-300 hover:text-white font-semibold text-sm">{t('nav.home')}</Link>
                  <Link to="/freebord" className="text-gray-300 hover:text-white font-semibold text-sm">{t('nav.freebord')}</Link>
                </div>
                <div className="flex flex-col gap-2 min-w-[80px]">
                  <span className="font-semibold text-blue-100 text-sm">{t('nav.eSkate')}</span>
                  <div className="flex flex-col gap-1">
                    <Link to="/products" className="text-gray-300 hover:text-white text-sm">{t('nav.ourProducts')}</Link>
                  </div>
                </div>
                <div className="flex flex-col gap-2 min-w-[80px]">
                  <span className="font-semibold text-blue-100 text-sm">{t('nav.accessories')}</span>
                  <div className="flex flex-col gap-1">
                    <Link to="/helmets" className="text-gray-300 hover:text-white text-sm">{t('nav.helmets')}</Link>
                    <Link to="/diy" className="text-gray-300 hover:text-white text-sm">{t('nav.diy')}</Link>
                    <Link to="/safety" className="text-gray-300 hover:text-white text-sm">{t('nav.safety')}</Link>
                    <Link to="/protective-equipment" className="text-gray-300 hover:text-white text-sm">{t('nav.protectiveEquipment')}</Link>
                  </div>
                </div>
                <div className="flex flex-col gap-2 min-w-[80px]">
                  <span className="font-semibold text-blue-100 text-sm">{t('nav.contact')}</span>
                  <div className="flex flex-col gap-1">
                    <Link to="/about" className="text-gray-300 hover:text-white text-sm">{t('nav.about')}</Link>
                    <Link to="/service" className="text-gray-300 hover:text-white text-sm">{t('nav.service')}</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="my-6 border-gray-700" />
        <div className="flex flex-wrap items-center md:justify-between justify-center">
          <div className="w-full md:w-4/12 px-4 mx-auto text-center">
            <div className="text-sm text-gray-400 font-semibold py-1">
              © {new Date().getFullYear()} BlueBoard
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
